// Prints a document loaded into a hidden iframe, then removes the iframe once printing is
// done. Cleanup also has a fallback timeout: `afterprint` isn't reliably fired in every
// browser (e.g. inconsistent Safari support for contentWindow.afterprint), which would
// otherwise leave the hidden iframe (and its blob URL, if owned by the caller) around.
const CLEANUP_FALLBACK_MS = 60000;

export function printBlobUrl(blobUrl, { revoke = false } = {}) {
  const iframe = document.createElement('iframe');
  iframe.style.display = 'none';
  document.body.appendChild(iframe);

  let cleaned = false;
  const cleanup = () => {
    if (cleaned) return;
    cleaned = true;
    if (iframe.parentNode) iframe.parentNode.removeChild(iframe);
    if (revoke) URL.revokeObjectURL(blobUrl);
  };

  iframe.onload = () => {
    const win = iframe.contentWindow;
    // Register before print(): in browsers where print() blocks (e.g. Chrome), afterprint
    // fires before print() returns, so a listener added afterwards would miss it.
    win.addEventListener('afterprint', cleanup);
    win.focus();
    win.print();
    setTimeout(cleanup, CLEANUP_FALLBACK_MS);
  };
  iframe.src = blobUrl;
}

export function printHtml(html) {
  const blobUrl = URL.createObjectURL(new Blob([html], { type: 'text/html' }));
  printBlobUrl(blobUrl, { revoke: true });
}
